module.exports = __webpack_public_path__ + "static/media/ic_annotation.46f54ee6.svg";